import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import BedColumn from './BedColumn';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

const BedSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$bed' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$bed' });

  return (
    <section className="home-section bed-section">
      <div className="home-heading mobile-dark mobile-border">
        <i className="home-icon icon-sleep-well mobile-dark" />
        <h2 className="home-title">{t('title')}</h2>
      </div>
      <div className="column-container">
        {/* TODO Add link to bed section */}
        <Link href={tLink('mattressBase')} className="bed-link">
          <img
            className="bed-img"
            src="/images/homePage/the-westin-heavenly-mattress-sleep-well.webp"
            alt={t('subtitle')}
            width={1630}
            height={762}
            loading="eager"
            decoding="async"
            fetchPriority="low"
          />
          <div className="stack-grey-bg">
            <h2 className="bed-title">{t('subtitle')}</h2>
            <div className="bed-columns">
              <BedColumn
                alt={t('column1Alt')}
                img="/images/homePage/icon-height.svg"
                title={t('column1Title')}
                description={t('column1Description')}
              />
              <BedColumn
                alt={t('column2Alt')}
                img="/images/homePage/icon-spring.svg"
                title={t('column2Title')}
                description={t('column2Description')}
              />
              <BedColumn
                alt={t('column3Alt')}
                img="/images/homePage/icon-motion.svg"
                title={t('column3Title')}
                description={t('column3Description')}
              />
              <BedColumn
                alt={t('column4Alt')}
                img="/images/homePage/icon-plush.svg"
                title={t('column4Title')}
                description={t('column4Description')}
              />
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default BedSection;
